<mat-nav-list>
    <!-- <div class="profile-card">
        <div class="header">
            <h2>Soufiane FADIL</h2>
            <h4>example@email.com</h4>
        </div>
        <img src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Soufiane FADIL">
    </div> -->

    <!-- <mat-divider></mat-divider> -->


    <h2 matSubheader>EXAM2X</h2>

    <a mat-list-item routerLinkActive="list-item-active" routerLink="/"><mat-icon>dashboard</mat-icon>Dashboard</a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/class"><mat-icon>class</mat-icon>Classes</a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/exam"><mat-icon>event_seat</mat-icon>Exam/Test</a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/student"><mat-icon>group</mat-icon>Student</a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/question-bank"><mat-icon>menu_book</mat-icon>Question bank</a>

    <mat-divider></mat-divider>

    <h2 matSubheader>Tools</h2>

    <a mat-list-item routerLinkActive="list-item-active" routerLink="/app-settings">
        <mat-icon>settings</mat-icon>
        App settings
    </a>
</mat-nav-list>
